import RecommendedItems from "./recommendedItems";
import OfferCard from "./offerCard";
import vendorIcon from "assets2/images/vendor-icon.webp";

import { Box, Link, Modal } from "@mui/material";
import { useState } from "react";

import "../../../../../styles/common.css";
import "../../../../../styles/responsive-common.css";
import { Payment_img } from "assets2/images/images";

const SpecialOffer: React.FC = () => {
  const [open, setOpen] = useState(false);
  const handleModalOpen = () => setOpen(true);
  const handleModalClose = () => setOpen(false);

  const recommendedItems = [
    {
      id: 0,
      src: "https://storage.googleapis.com/content.paysfer.com/banner/Recommended-Items-Tiles-1.webp",
      productName: "Kids bike",
    },
    {
      id: 1,
      src: "https://storage.googleapis.com/content.paysfer.com/Paysfer%20Homepage/home_page_socks.jpg",
      productName: "Socks",
    },
    {
      id: 2,
      src: "https://storage.googleapis.com/content.paysfer.com/banner/Recommended-Items-Tiles-2.webp",
      productName: "Kids Jewelry",
    },
    {
      id: 3,
      src: "https://storage.googleapis.com/content.paysfer.com/Paysfer%20Homepage/home_page_lamps.jpg",
      productName: "Lamps",
    },
  ];

  const offerCardItems1 = [
    {
      id: 0,
      src: "https://storage.googleapis.com/content.paysfer.com/specialOffer/Updated_Images/homePage_top%20collections_handbag%20tile.webp",
      productName: "Bags",
    },
    {
      id: 1,
      src: "https://storage.googleapis.com/content.paysfer.com/specialOffer/Updated_Images/homePage_top%20collections_Hats%20Tile.webp",
      productName: "Hats",
    },
    {
      id: 2,
      src: "https://storage.googleapis.com/content.paysfer.com/specialOffer/Updated_Images/specialOffer_Arts%20and%20Crafts-18.webp",
      productName: "Mugs",
    },
    {
      id: 3,
      src: "https://storage.googleapis.com/content.paysfer.com/specialOffer/Updated_Images/homePage_top%20collections_Board%20Games%20tile.webp",
      productName: "Games",
    },
  ];

  const offerCardItems2 = [
    {
      id: 0,
      src: "https://storage.googleapis.com/content.paysfer.com/banner/Recommended-Items-Tiles-3.webp",
      productName: "Gift",
    },
    {
      id: 1,
      src: "https://storage.googleapis.com/content.paysfer.com/banner/wallets_tile.jpg",
      productName: "Wallets",
    },
    {
      id: 2,
      src: "https://storage.googleapis.com/content.paysfer.com/banner/handbags_tile.jpg",
      productName: "Handbags",
    },
    {
      id: 3,
      src: "https://storage.googleapis.com/content.paysfer.com/specialOffer/Updated_Images/homePage_top%20collections_Keychains%20tile.webp",
      productName: "Keychain",
    },
  ];

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    display: "flex",
  };

  const openResellPlace = () => {
    window.open("https://resell.ooo/", "_blank");
  };

  return (
    <section className="special-offer-section custom-spacer">
      <div className="container-fluid">
        <div className="common-heading text-center d-none d-lg-block">
          <h3 className="text-uppercase">SPECIAL OFFER</h3>
          <h4 className="text-uppercase">TOP COLLECTIONS OF 2022 & 2023</h4>
        </div>
        <div className="row">
          <div className="col-md-6 col-lg-6 col-xl-3 clothing-div">
            <OfferCard offerItems={offerCardItems1} />
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3 super-deals-div">
            <OfferCard offerItems={offerCardItems2} />
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3 super-deals-div">
            <OfferCard offerItems={recommendedItems} />
          </div>
          <div className="col-md-6 col-lg-6 col-xl-3 super-deals-div">
            <div className="offer-card">
              <span className="resell-banner-title">Sell your used items</span>
              <Link onClick={openResellPlace} style={{ cursor: "pointer" }}>
                <img
                  src="https://storage.googleapis.com/content.paysfer.com/Paysfer%20Homepage/new_resell_logo.jpg"
                  style={{
                    display: "block",
                    maxWidth: "100%",
                    padding: "20px",
                    cursor: "ponter",
                  }}
                  loading="lazy"
                />
              </Link>
              <span className="resell-banner-button" onClick={openResellPlace}>
                Go to ReSell.ooo
              </span>
            </div>

            <Modal open={open} onClose={handleModalClose}>
              <Box sx={style}>
                <div>
                  Please email us at <Link>seller@paysfer.com</Link> with your
                  company info, types of products you sell, contact person and a
                  phone number.
                </div>
                <button className="btn btn-primary" onClick={handleModalClose}>
                  Close
                </button>
              </Box>
            </Modal>
          </div>
        </div>
        <div className="row"></div>
      </div>
    </section>
  );
};

export default SpecialOffer;
